import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select', 'images'];

  connect() {
    this.updateImage();
  }

  updateImage() {
    const value = this.selectTarget.value;
    this.imagesTargets.forEach((image) => {
      const name = image.dataset.name;
      if (name == value) {
        image.classList.remove('d-none');
      } else {
        image.classList.add('d-none');
      }
    });
  }
}
